import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '../shared/modal/modal.component';
import { BatchDeclineItem } from '../model/batch-decline';
import { DeclineItemListComponent } from '../decline-item-list/decline-item-list.component';

@Component({
  selector: 'decline-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent, DeclineItemListComponent],
  templateUrl: './decline-dialog.component.html',
  styleUrl: './decline-dialog.component.scss',
})
export class DeclineDialogComponent {
  @Input() siteId = '';
  @Input() active: boolean = false;
  @Input() multiple: boolean = false;
  @Input() items: BatchDeclineItem[] = [];
  @Input() scopeLabel: string = '';
  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() isFixedPrice: boolean = false;
  @Input() isAtp: boolean = false;

  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() decline = new EventEmitter<any>();

  title: string = 'Decline RFP Invitation';
  reasonSelectedIndex: number = 0;
  otherReason: string = '';
  comments: string = '';
  isDisabled: boolean = true;

  // Hard cap on the decline free-text fields — matches Salesforce's
  // `Decline_Reason__c` 255 limit. Enforced via each field's `maxlength`
  // (UX-only; connect-service enforces it server-side).
  readonly maxCommentLength = 255;

  declineReasons = [
    { value: '0', label: 'Please select a reason' },
    { value: '1', label: 'The site is not within my service area' },
    { value: '2', label: 'This service is not within my scope' },
    { value: '3', label: 'I am currently unavailable' },
    {
      value: '4',
      label: 'The timeline to complete this project is too short',
    },
    { value: '5', label: 'Other' },
  ];

  ngOnInit() {
    if (this.isAtp) {
      this.title = 'Decline To Sign ATP';
    } else if (this.isFixedPrice) {
      this.title = 'Decline Offer';
    }
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  declineInvitation() {
    this.isDisabled = true;
    this.closeDialog();
    this.decline.emit({
      declineReason: this.declineReasons[this.reasonSelectedIndex]?.label,
      declineOtherReason: this.otherReason,
      declineComments: this.comments,
    });
  }

  checkOtherReason() {
    this.isDisabled = this.otherReason.trim().length === 0;
  }

  selectReason(val: any) {
    this.reasonSelectedIndex = val.target.selectedIndex;
    // Only "Other" carries free text; drop it on any other reason so a stale
    // value is never emitted and "Other" starts empty if re-selected.
    if (this.reasonSelectedIndex !== 5) {
      this.otherReason = '';
    }
    if (this.reasonSelectedIndex > 0 && this.reasonSelectedIndex < 5) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }
}
